import { createLazyOrchestrator } from 'owa-bundling';
import { goToDate } from 'owa-calendar-module-commanding';
import { updateSelectedDate } from 'owa-calendar-surface';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { processDateRangeChange } from 'owa-calendar-surface-view-store';
import { createDateRangeFromType } from 'owa-datetime-utils';
import { navigateCalendarAssetToDate } from 'owa-timestream-asset-sdk-actions';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Ideally we can find a way to eventually differentiate module concerns (e.g. selected date)
// from concerns that are specific to traditional surface view, but right now we need to
// continue overloading the calendar surface store to also track some module concerns
// and update them regardless of current view context in order to keep features like
// left-nav mini month working correctly

export const goToDateOrchestrator = createLazyOrchestrator(
    goToDate,
    'goToDate_CLONE',
    actionMessage => {
        const { selectedDate } = actionMessage;
        const surfaceStore = getSurfaceStore();

        const newDateRange = createDateRangeFromType(
            surfaceStore.dateRangeType,
            selectedDate,
            surfaceStore.userOptions.weekStartDay,
            surfaceStore.userOptions.workDays,
            getNumDaysInDayRange()
        );

        processDateRangeChange(newDateRange);
        updateSelectedDate(selectedDate, surfaceStore);

        navigateCalendarAssetToDate(selectedDate);
    }
);
